module.exports = __webpack_public_path__ + "static/img/aboutUs17.18f5038.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs17.jpg
// module id = 1369
// module chunks = 1